import { c as _c } from "react/compiler-runtime";
import { MarkerF, MarkerProps } from "@react-google-maps/api";
import React from "react";
export default function MarkerV2(props) {
  const $ = _c(7);
  const t0 = props.icon as string || "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      url: t0,
      scale: 1
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.onClick || $[3] !== props.options || $[4] !== props.position || $[5] !== t1) {
    t2 = <MarkerF position={props.position} onClick={props.onClick} options={props.options} icon={t1} />;
    $[2] = props.onClick;
    $[3] = props.options;
    $[4] = props.position;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}